/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:31 2019-07-06
 */
import Keep from "../layout/keep";
import Layout from '../layout/layout';

let ReportComapny = [
	{
		path: '/:type/reportManage',
		name: 'reportManage',
		meta: {title: '报表管理'},
		component: Layout,
		children: [
			{
				path: 'tendencyAnalyse',
				meta: {title: '趋势分析'},
				name: 'tendencyAnalyse',
				component: Keep,
				children: [
					{
						path: 'index',
						meta: {title: '趋势分析'},
						name: 'report-manage-tendency-analyse',
						component: () => import('src/pages/reportManage/tendencyAnalyse/tendencyAnalyse'),
					}
				]
			},{
				path: 'singleStationReport',
				meta: {title: '单站点报表'},
				name: 'singleStationReport',
				component: Keep,
				children: [
					{
						path: 'index',
						meta: {title: '趋势分析'},
						name: 'report-manage-single-station-report',
						component: () => import('src/pages/reportManage/singleStationReport/singleStationReport'),
					}
				]
			},{
				path: 'synthesizeReport',
				meta: {title: '综合报表'},
				name: 'synthesizeReport',
				component: Keep,
				children: [
					{
						path: 'index',
						meta: {title: '综合报表'},
						name: 'report-manage-synthesize-report',
						component: () => import('src/pages/reportManage/synthesizeReport/synthesizeReport'),
					}
				]
			},
		]
	},
]

export default ReportComapny
